var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sso-layout-container"},[_c('sso-header'),_c('router-view'),_c('sso-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }